export const enum ButtonsTypes {
    SUBTITLE = "subtitle",
    AUDIO = "audio",
    OFF = "off"
};
